export { default } from './store-locator.component';
